import { render, staticRenderFns } from "./DeleteVoucher.vue?vue&type=template&id=5c244d1a"
import script from "./DeleteVoucher.vue?vue&type=script&lang=js"
export * from "./DeleteVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports